import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import {errorCodeTranslation} from "../../Apis/ErrorCode";
import {ResponseApi} from "../BaseApi";

const CardsSlice = createSlice({
    name: 'cards',
    initialState: {
        createResourceApi: null,
        getAllCardFormats: [],
        createSingleCard: null,
        createMultipleCards: null,
        assignCardToUser: null,
        assignTemplateToCards: {},
        analizeCards: null,
        createTemplateCard: null,
        updateTemplateCard: null,
        getPreview: null,
        selectedCardsR: null,
    },
    reducers: {
        clearPreview: (state, action) => {
            state.getPreview = null;
        },
        setSelectedCardsR: (state, action) => {
            state.selectedCardsR = action.payload;
        },
    },
    extraReducers: {
        'cards/createSingleCard/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
            } else if (status >= 400 && status < 600) {
                if (!(data?.code && errorCodeTranslation[data?.code])) {
                    toast.error(t('something_went_wrong_2'));
                }
            }
        },
        'cards/createMultipleCards/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
            } else if (status >= 400 && status < 600) {
                if (!(data?.code && errorCodeTranslation[data?.code])) {
                    toast.error(t('something_went_wrong_2'));
                }
            }
        },
        'cards/analizeCards/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.analizeCards = data;
            }
        },
        'cards/getAllCardFormats/fulfilled': (state, action) => {
            state.getAllCardFormats = ResponseApi(action.payload);
        },
        'cards/assignCardToUser/fulfilled': (state, action) => {
            state.assignCardToUser = ResponseApi(action.payload);
        },

        'cards/assignTemplateToCards/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_assigned_successfully'));
            }
        },
        'cards/createTemplateCard/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createTemplateCard = data;
            }
        },
        'cards/updateTemplateCard/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        clearPreview: (state) => {
            state.getPreview = [];
        },
    },
});

export const { clearPreview, setSelectedCardsR } = CardsSlice.actions;

export default CardsSlice.reducer;
